import React, { useState } from 'react';
import '../styles/ProductComparison.css';

const ProductComparison = () => {
  const [showAllFeatures, setShowAllFeatures] = useState(false);

  const products = [
    {
      id: 1,
      name: 'QuickFit ANC R',
      tagline: 'Essential Rechargeable',
      badge: 'Best Seller',
      features: {
        'Battery Type': 'Rechargeable Lithium-ion',
        'Battery Life': 'Up to 10 hours',
        'Battery Life With Charging Case': 'Up to 50 hours',
        'Charging Time': '1-2 hours',
        'Charger Type': 'Charging Base with LED Display',
        'Bluetooth': 'No',
        'Display': 'LED Display',
        'Volume Control': 'Manual',
        'Dry & Clean': 'No',
        'Noise Cancellation': 'Advanced ANC',
        'Weight': '50g per unit',
        'Warranty': '1 Year',
       
      },
      price: 'B2B Price on Request',
      isPopular: false
    },
    {
      id: 2,
      name: 'QuickFit ANC BT R D',
      tagline: 'Premium with Display',
      badge: 'New Launch',
      features: {
        'Battery Type': 'Rechargeable Lithium-ion',
        'Battery Life': 'Up to 15 hours',
        'Battery Life With Charging Case': 'Up to 40 hours',
        'Charging Time': '1-2 hours',
        'Charger Type': 'Portable Travel Charger with Display',
        'Bluetooth': 'Yes, Bluetooth 5.0',
        'Display': 'LED Display',
        'Volume Control': 'Remote Control + Bluetooth',
        'Dry & Clean': 'No',
        'Noise Cancellation': 'Advanced ANC',
        'Weight': '78g per unit',
        'Warranty': '1 Year',
       
      },
      price: 'B2B Price on Request',
      isPopular: true
    },
    {
      id: 3,
      name: 'QuickFit ANC BT R DC',
      tagline: 'Ultimate with Dry & Clean',
      badge: 'New Launch',
      features: {
        'Battery Type': 'Rechargeable Lithium-ion',
        'Battery Life': 'Up to 20 hours',
        'Battery Life With Charging Case': 'Up to 40 hours',
        'Charging Time': '1-2 hours',
        'Charger Type': 'Portable Travel Charger with Dry & Clean',
        'Bluetooth': 'Yes, Bluetooth 5.2',
        'Display': 'LED Touch Display',
        'Volume Control': 'Manual + Bluetooth',
        'Dry & Clean': 'Yes, with UV Sterilization',
        'Noise Cancellation': 'Advanced ANC Pro',
        'Weight': '68g per unit',
        'Warranty': '1 Years',
       
      },
      price: 'B2B Price on Request',
      isPopular: false
    }
  ];

  // All feature keys for comparison in desired order
  const allFeatures = [
    'Battery Type',
    'Battery Life',
    'Battery Life With Charging Case',
    'Charging Time',
    'Charger Type',
    'Bluetooth',
    'Display',
    'Volume Control',
    'Dry & Clean',
    'Noise Cancellation',
    'Weight',
    'Warranty',
    'Colors'
  ];

  const getFeatureValue = (product, feature) => {
    return product.features[feature] || '—';
  };

  return (
    <section id="comparison" className="product-comparison-section">
      <div className="product-comparison-container">
        
        {/* Section Header */}
        <div className="product-comparison-header">
          <span className="product-comparison-tagline">Compare Models</span>
          <h2 className="product-comparison-title">
            Find the <span className="product-comparison-highlight">Perfect Fit</span>
          </h2>
          <div className="product-comparison-underline"></div>
          <p className="product-comparison-subtitle">
            Compare features side by side to choose the right hearing aid for your clinic or distribution needs
          </p>
        </div>

        {/* Comparison Table */}
        <div className="product-comparison-table-wrapper">
          <table className="product-comparison-table">
            <thead>
              <tr>
                <th className="product-comparison-feature-cell">Features</th>
                {products.map((product) => (
                  <th key={product.id} className={`product-comparison-product-cell ${product.isPopular ? 'popular' : ''}`}>
                    <div className="product-comparison-product-header">
                      {product.badge && <span className="product-comparison-product-badge">{product.badge}</span>}
                      <h3 className="product-comparison-product-name">{product.name}</h3>
                      <p className="product-comparison-product-tagline">{product.tagline}</p>
                      <div className="product-comparison-product-price">{product.price}</div>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {allFeatures.map((feature, index) => (
                <tr key={feature} className={index % 2 === 0 ? 'even' : 'odd'}>
                  <td className="product-comparison-feature-cell">
                    <strong>{feature}</strong>
                  </td>
                  {products.map((product) => (
                    <td key={product.id} className="product-comparison-value-cell">
                      {getFeatureValue(product, feature)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Card View (for small screens) */}
        <div className="product-comparison-mobile">
          {products.map((product) => (
            <div key={product.id} className="product-comparison-mobile-card">
              <div className="product-comparison-mobile-header">
                {product.badge && <span className="product-comparison-mobile-badge">{product.badge}</span>}
                <h3 className="product-comparison-mobile-name">{product.name}</h3>
                <p className="product-comparison-mobile-tagline">{product.tagline}</p>
                <div className="product-comparison-mobile-price">{product.price}</div>
              </div>
              <div className="product-comparison-mobile-features">
                {allFeatures.map((feature) => (
                  <div key={feature} className="product-comparison-mobile-feature">
                    <span className="product-comparison-mobile-feature-label">{feature}</span>
                    <span className="product-comparison-mobile-feature-value">
                      {getFeatureValue(product, feature)}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Recommendation Banner */}
        <div className="product-comparison-recommendation">
          <div className="product-comparison-recommendation-icon">⭐</div>
          <div className="product-comparison-recommendation-content">
            <h3>Need Help Choosing?</h3>
            <p>Our experts can help you select the right product based on your clinic needs and budget</p>
          </div>
          <a href="/contact" className="product-comparison-recommendation-btn">
            Talk to Expert →
          </a>
        </div>

        {/* Bulk Inquiry Note */}
        <div className="product-comparison-note">
          <span className="product-comparison-note-icon">💼</span>
          <span className="product-comparison-note-text">
            Special pricing available for bulk orders. Contact us for distributor pricing and volume discounts.
          </span>
        </div>

      </div>
    </section>
  );
};

export default ProductComparison;